import { useState, useContext, useCallback, memo, useEffect } from 'react'
import '../assets/css/Navbar.css'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes, faCaretDown, faSearch, faClose, faHeart } from '@fortawesome/free-solid-svg-icons'
import UserContext from '../context/UserContext'
import { useModalContext } from '../context/ModalContext'
import { getImageUrl } from '../services/CommonService'
import Search from 'antd/es/input/Search'
import { setIsPreviousButtonDisabled, setReachedFirstPage } from '../context/ArticlesContextActions'
import ArticlesContext from '../context/ArticlesContext'
import { logoutUser } from '../services/UserService'


const Navbar = memo(function Navbar() {
    const [open, setOpen] = useState(false)
    const [loginDropdownOpen, setLoginDropdownOpen] = useState(false)
    const [searchExpanded, setSearchExpanded] = useState(false) 
    const { displayPrijavaModal, displayGenericErrorModal } = useModalContext()
    const { userRole, clearUserContext } = useContext(UserContext)
    const { dispatch } = useContext(ArticlesContext)
    const location = useLocation()
    const navigate = useNavigate()

    const isActiveRoute = useCallback((route) => {
        return location.pathname === route
    }, [location.pathname])

    useEffect(() => {
        setOpen(false);
    }, [location.pathname, setOpen]);


    /** Conditional CSS class names */
    const openedClassName = open ? "opened" : ""

    const closeLoginDropdown = useCallback(() => {
        setLoginDropdownOpen(false)
    }, [setLoginDropdownOpen])

    const handleOpenModal = useCallback(() => {
        displayPrijavaModal()
        closeLoginDropdown() // because it opened on hover
        setOpen(false)
    }, [displayPrijavaModal, closeLoginDropdown])

    const handleNavbarToggle = useCallback(() => {
        setOpen(!open)
    }, [setOpen, open])

    const closeNavbarIfOpened = useCallback(() => {
        if (open) setOpen(false)
    }, [setOpen, open])

    const handleSearchToggle = useCallback(() => {
        setSearchExpanded(!searchExpanded)
    }, [setSearchExpanded, searchExpanded])

    const handleDropdownToggle = useCallback(() => {
        setLoginDropdownOpen(!loginDropdownOpen)
    }, [setLoginDropdownOpen, loginDropdownOpen])

    const openLoginDropdown = useCallback(() => {
        setLoginDropdownOpen(true)
    }, [setLoginDropdownOpen])

    const handleLogOut = useCallback(() => {
        logoutUser()
        .then(data => {
            clearUserContext()
            navigate('/')
        })
        .catch(error => {
            displayGenericErrorModal()
        })
        closeLoginDropdown()
        setOpen(false)
    }, [closeLoginDropdown, clearUserContext, displayGenericErrorModal, navigate])

    const onSearchArticles = useCallback((value, _e) => {
        if (value && value.length < 20) {
            navigate("/?q=" + value)
            // Set initial values
            dispatch(setIsPreviousButtonDisabled(true))
            dispatch(setReachedFirstPage(false))
            // Close all dropdowns
            closeNavbarIfOpened()
            handleSearchToggle()
        }
    }, [dispatch, closeNavbarIfOpened, handleSearchToggle, navigate])


    return (
        <div className='Navbar-Container'>
             <div className='mobile-header'>
                {/** Search icon */}
                {<div className='flex-container center-align'>
                    {!open && !searchExpanded && (<FontAwesomeIcon icon={faSearch} className="burger" onClick={handleSearchToggle} />)}
                    {open && !searchExpanded && (<FontAwesomeIcon icon={faSearch} className="burger" onClick={handleSearchToggle} />)}
                    {!open && searchExpanded && (<FontAwesomeIcon icon={faClose} className="burger search-input" onClick={handleSearchToggle} />)}
                    {open && searchExpanded && (<FontAwesomeIcon icon={faClose} className="burger search-input" onClick={handleSearchToggle} />)}
                </div>}

                <NavLink to='/donacije' className="burger">
                    <FontAwesomeIcon icon={faHeart} className="burgundy-color" />
                </NavLink>
                
                {<p className='smaller-screen-width-page-name'>
                    <NavLink reloadDocument to='/'>
                        <img src={getImageUrl('historiografija-logo.png')} alt='Logo historiografija.ba' />
                    </NavLink>
                </p>}

                {/** Burger icon */}
                {!open && (<FontAwesomeIcon icon={faBars} className="burger" onClick={handleNavbarToggle} />)}
                {open && (<FontAwesomeIcon icon={faTimes} className="burger" onClick={handleNavbarToggle} />)}
             </div>

            {/** This search input is isplayed only on smaller screens (because it is below the Navbar) */}
            {searchExpanded && <Search placeholder="Pretražite pojam..."
                allowClear
                size='large'
                onSearch={onSearchArticles}
                className='mobile-search-input'
                style={{
                    width: '100%',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center'
                }}
                maxLength={20}
            />}

            <p className='logo-navbar'>
                <NavLink reloadDocument to='/'>
                    <img src={getImageUrl('historiografija-logo.png')} alt='Logo historiografija.ba' />
                </NavLink>
            </p>

            <ul className={`Navbar ${openedClassName} full-width`}>
                {!open && <Search placeholder="Pretražite pojam..."
                    allowClear
                    onSearch={onSearchArticles}
                    style={{
                        width: '30%',
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                    maxLength={20}
                />}
                <li>
                    <NavLink to='/' reloadDocument className={({isActive}) => (isActive ? "active-navbar navbar-link" : "navbar-link")}>Početna</NavLink>
                </li>
                <li>
                    <NavLink to='/autori' className={({isActive}) => (isActive ? "active-navbar navbar-link" : "navbar-link")}>Autori</NavLink>
                </li>
                <li>
                    <NavLink to='/serijali' className={({isActive}) => (isActive ? "active-navbar navbar-link" : "navbar-link")} end>Serijali</NavLink>
                </li>
                <li>
                    <NavLink to='/impressum' className={({isActive}) => (isActive ? "active-navbar navbar-link" : "navbar-link")}>Impressum</NavLink>
                </li>
                <li>
                    <NavLink to='/donacije' className={({isActive}) => (isActive ? "active-navbar navbar-link" : "navbar-link")}>Donacije</NavLink>
                </li>
                {/**PRIJAVA ONLY FOR NOT LOGGED IN USERS, OTHERWISE 'PROFIL/Odjavi se' */}
                {userRole != null ? 
                    <li className='pointer-cursor navbar-link' onMouseEnter={openLoginDropdown} onClick={handleDropdownToggle}>
                        Profil
                        <FontAwesomeIcon icon={faCaretDown} className='left-margin'></FontAwesomeIcon>
                    </li>
                    :
                    <li>
                        <NavLink onClick={() => handleOpenModal()} className="navbar-link">Prijava</NavLink>
                    </li>                    
                }
                {(userRole != null && loginDropdownOpen) && 
                    <div className='dropdown'>
                        <ul className='dropdown-content' onMouseLeave={closeLoginDropdown}>
                            <li>
                                <NavLink to='/profil' className={({isActive}) => (isActive ? "active-navbar navbar-link" : "navbar-link")}>Moj profil</NavLink>
                            </li>
                            <li onClick={handleLogOut} className='pointer-cursor navbar-link'>
                                Odjavi se
                            </li>
                        </ul>
                    </div>
                }
            </ul>
        </div>
    )
})

export default Navbar